app.factory('appService', ['$rootScope', '$window', '$state', function ($rootScope, $window, $state) {
	var service = this;

	service.userAgent = $window.navigator.userAgent;

	console.log('appService: initializing app service with userAgent: ' + service.userAgent);

	service.isApp = function() {
		// Treat the user agent as an app if it contains our
		// special user agent.
		if (service.userAgent.indexOf("FagligeDage/") !== -1) {
			return true;
		}
		// Treat all /student pages as being an "app".
		if (window.location.pathname.indexOf("/student") === 0) {
			return true;
		}
		// Treat all /teacherapp pages as being an "app".
		if (window.location.pathname.indexOf("/teacherapp") === 0) {
			return true;
		}
		return false;
	}();

	// These two are filled out on login via authService.
	service.isStudentApp = false;
	service.isTeacherApp = false;

	service.isTeacherBackendSystem = function() {
		if (window.location.pathname.indexOf("/teacher") === 0 && window.location.pathname.indexOf("/teacherapp") !== 0) {
			return true;
		}
		return false;
	}

	service.isAdminSystem = function() {
		return !service.isTeacherBackendSystem() && !service.isApp;
	}

	service.isiOS = function() {
		if (service.userAgent.indexOf("FagligeDageiOS/") !== -1) {
			return true;
		}
		return false;
	}

	service.isiPhoneX = function() {
		if (service.userAgent.indexOf("FageligeDageiPhoneX/") !== -1) {
			return true;
		}
		return false;
	}

	service.isAndroid = function() {
		if (service.userAgent.indexOf("FagligeDageAndroid/") !== -1) {
			return true;
		}
		return false;
	}

	service.clearCookies = function() {
		if (service.isiOS()) {
			var handler = window.webkit.messageHandlers["clearCookies"];
			if (handler != null) {
				handler.postMessage({});
			}
		}
		if (service.isAndroid()) {
			window.tuAndroid.clearCookies();
		}
	}

	service.setCookieState = function(state) {
		if (service.isiOS()) {
			var handler = window.webkit.messageHandlers["setCookieState"];
			if (handler != null) {
				handler.postMessage(state);
			}
			return;
		}
		if (service.isAndroid()) {
			window.tuAndroid.setCookieState(state);
			return;
		}
		console.log('appService: setCookieState: ' + state);
	}

	service.showCookieDialog = function() {
		$rootScope.$broadcast('cookieDialogForceShow');
	}

	service.showCookieRemoveDialog = function() {
		$rootScope.$broadcast('cookieDialogForceShowRemove');
	}

	return service;
}]);
